{
  "polygons": [
    [
      {
        "latitude": 45.4968008208597,
        "longitude": -73.5793439052364
      },
      {
        "latitude": 45.4968371021925,
        "longitude": -73.5794198040332
      },
      {
        "latitude": 45.4968257575084,
        "longitude": -73.5794309881814
      },
      {
        "latitude": 45.4968319411297,
        "longitude": -73.5794438980169
      },
      {
        "latitude": 45.4967386830908,
        "longitude": -73.5795344362081
      },
      {
        "latitude": 45.4967324717897,
        "longitude": -73.579521338355
      },
      {
        "latitude": 45.4967107583698,
        "longitude": -73.5795423136647
      },
      {
        "latitude": 45.496674477241,
        "longitude": -73.5794664151307
      },
      {
        "latitude": 45.4968008208597,
        "longitude": -73.5793439052364
      }
    ]
  ],
  "location": {
    "latitude": 45.496803,
    "longitude": -73.57945649999999
  },
  "buildingCode": "FA",
  "buildingName": "FA Annex",
  "overview": [
    "The FA Annex, a three-storey Victorian house built in 1875, stands out with its steep slate roof, detailed dormer windows and prominent stone bay window at the front.",
    "Once home to notable Montrealers, it became part of the university in 1970. Today, it hosts offices and student services, including part of the Department of Religions and Cultures."
  ],
  "departments": [
    {
      "name": "Religions and Cultures",
      "url": "https://www.concordia.ca/artsci/religions-cultures.html"
    }
  ],
  "accessibility": [],
  "address": "2060 Mackay St.",
  "campus": "SGW",
  "url": "https://www.concordia.ca/maps/buildings/fa.html"
}